module.exports = __webpack_public_path__ + "media/site/images/factories/success-story-f8f4c9a362f1772ccaf2cf2bc5956a7c.jpg";